/** Timetables, out-of-service areas, points of interest, news, reports and push notifications. */
export default {
  // Timetables
  'New timetable': 'Orar i ri',
  Timetable: 'Orari',
  'All lines': 'Të gjitha linjat',
  Weekdays: 'Ditët e javës',
  Weekend: 'Fundjava',
  First: 'E para',
  '{n} departure': '{n} nisje',
  '{n} departures': '{n} nisje',
  '06:00 06:20 … (Enter, comma or paste)': '06:00 06:20 … (Enter, presje ose ngjitni)',
  'Weekdays ({n})': 'Ditët e javës ({n})',
  'Weekend ({n})': 'Fundjava ({n})',

  // Out-of-service areas
  'Depots and garages: buses inside these areas are hidden from the app.':
    'Depot dhe garazhet: busat brenda këtyre zonave nuk shfaqen në aplikacion.',
  'New area': 'Zonë e re',
  'New out-of-service area': 'Zonë e re jashtë funksionit',
  Area: 'Zona',
  Drawn: 'E vizatuar',
  'Draw the area on the map': 'Vizatoni zonën në hartë',

  // Points of interest
  'New point': 'Pikë e re',
  'New point of interest': 'Pikë e re e interesit',
  Category: 'Kategoria',
  Status: 'Statusi',
  Hidden: 'Fshehur',
  Link: 'Linku',
  Icon: 'Ikona',
  Photo: 'Fotografia',
  Position: 'Pozita',
  'Click on the map': 'Klikoni në hartë',
  Visible: 'E dukshme',

  // News
  "Articles in the app's information tab, newest first.":
    'Artikujt në skedën e informatave të aplikacionit, më të rinjtë së pari.',
  'New article': 'Artikull i ri',
  'Edit article': 'Ndrysho artikullin',
  Article: 'Artikulli',
  Published: 'Publikuar',
  Edited: 'Ndryshuar',
  Summary: 'Përmbledhja',
  '{n}/160 characters, shown in the list': '{n}/160 karaktere, shfaqet në listë',

  // Reports
  'Feedback sent from the app. Replying notifies the passenger.':
    'Komentet e dërguara nga aplikacioni. Përgjigjja e njofton pasagjerin.',
  Open: 'Të hapura',
  Archived: 'Arkivuar',
  All: 'Të gjitha',
  'Any reply state': 'Çdo gjendje përgjigjeje',
  'Not replied': 'Pa përgjigje',
  Replied: 'U përgjigj',
  Received: 'Pranuar',
  State: 'Gjendja',
  'Reply read': 'Përgjigjja u lexua',
  'Needs reply': 'Pret përgjigje',
  'Reply sent': 'Përgjigjja u dërgua',
  Restored: 'U rikthye',
  Archive: 'Arkivo',
  Restore: 'Rikthe',
  Message: 'Mesazhi',
  Reply: 'Përgjigjja',
  'Write a reply': 'Shkruani një përgjigje',
  'read by the passenger': 'lexuar nga pasagjeri',
  'not read yet': 'ende e palexuar',
  'Replace the reply…': 'Zëvendësoni përgjigjen…',
  'Your reply to the passenger…': 'Përgjigjja juaj për pasagjerin…',
  'Send reply': 'Dërgo përgjigjen',
  'Saved. The passenger has no push token, so they will see it next time they open their reports.':
    'U ruajt. Pasagjeri nuk ka token për njoftime push, prandaj do ta shohë herën tjetër kur të hapë raportet e veta.',
  Passenger: 'Pasagjeri',
  'E-mail': 'E-mail',
  Phone: 'Telefoni',
  'Call hours': 'Orari i thirrjeve',
  'Shown in the app as written, e.g. 05:30 - 23:30':
    'Shfaqet në aplikacion siç shkruhet, p.sh. 05:30 - 23:30',
  'Signed in with': 'I kyçur me',

  // Push notifications
  'Sent to all app users': 'U dërgua te të gjithë përdoruesit e aplikacionit',
  'Saved, but sending failed. Check the Firebase configuration.':
    'U ruajt, por dërgimi dështoi. Kontrolloni konfigurimin e Firebase.',
  'Messages sent to every app user.': 'Mesazhet e dërguara te çdo përdorues i aplikacionit.',
  'New notification': 'Njoftim i ri',
  'No notifications sent yet': 'Ende nuk është dërguar asnjë njoftim',
  Sent: 'Dërguar',
  By: 'Nga',
  'New push notification': 'Njoftim i ri push',
  'Send…': 'Dërgo…',
  'Goes to every phone with the app installed': 'Shkon në çdo telefon që e ka të instaluar aplikacionin',
  'Send now': 'Dërgo tani',
  'Send to all users?': 'Të dërgohet te të gjithë përdoruesit?',
  'Departure times per direction and station, shown in the app.':
    'Oraret e nisjes për çdo drejtim dhe stacion, të shfaqura në aplikacion.',
} satisfies Record<string, string>;
